import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import PaidHero from "../../../../../../patterns/paid-hero";

const jsmHeroStyles = css({
    "backgroundImage":
        "linear-gradient(287.15deg, #FAFBFC 0%, #DEEBFF 8.06%, #B3D4FF 35.45%, #DEEBFF 77.6%, #FAFBFC 100%)",
    "@media (min-width: 1024px)": {
        backgroundImage:
            "url(https://wac-cdn.atlassian.com/dam/jcr:f96e5a0a-7af5-4cc6-884c-b51416e65e41/JSM_BG%20Graphics.png?cdnVersion=ece) , linear-gradient(287.15deg, #FAFBFC 0%, #DEEBFF 8.06%, #B3D4FF 35.45%, #DEEBFF 77.6%, #FAFBFC 100%)"
    },
    "backgroundPosition": "top right , 0 0",
    "backgroundRepeat": "no-repeat , no-repeat",
    "backgroundSize": "auto 100% , auto",
    ".payHero-subTertiary": {
        fontSize: "1rem",
        lineHeight: "1.5",
        textAlign: "center",
        fontWeight: "600"
    }
});

const HeroSectionPaidLpJswPm = () => {
    const intl = useIntl();
    const subTertiaryTextValueStrongText = intl.formatMessage({
        id: "JiraSoftwarePage.PaidLpJswPm.subTertiaryText.strongText",
        defaultMessage: "INCLUDED IN YOUR FREE PLAN"
    });
    const subTertiaryTextValuePlainText = intl.formatMessage({
        id: "JiraSoftwarePage.PaidLpJswPm.subTertiaryText.plainText",
        defaultMessage: ": Forever free for up to 10 users"
    });
    const subTertiaryTextNode = (
        subTertiaryTextValueStrongText: string,
        subTertiaryTextValuePlainText: string
    ) => (
        <>
            <strong>{subTertiaryTextValueStrongText}</strong>
            {subTertiaryTextValuePlainText}
        </>
    );

    return (
        <div css={jsmHeroStyles} id="start-trial">
            <PaidHero
                headerText={intl.formatMessage({
                    id: "JiraSoftwarePage.PaidLpJswPm.heroHeader",
                    defaultMessage: "Project management made easy"
                })}
                secondaryText={intl.formatMessage({
                    id: "JiraSoftwarePage.PaidLpJswPm.heroBody",
                    defaultMessage:
                        "Jira connects over 250K teams to make work less manual"
                })}
                image={{
                    src: "https://wac-cdn.atlassian.com/dam/jcr:46d95258-0a75-4c1c-a840-495e6237f238/HERO%20ROADMAPS@2x.png?cdnVersion=ece",
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePage.PaidLpJswPm.heroImageAlt",
                        defaultMessage: "Roadmaps"
                    })
                }}
                subTertiaryText={subTertiaryTextNode(
                    subTertiaryTextValueStrongText,
                    subTertiaryTextValuePlainText
                )}
            />
        </div>
    );
};

export default HeroSectionPaidLpJswPm;
